import LinkSortFilterDialog from './link-sort-filter-dialog'

class LinkSortFilterService {
    $lv

    get instance() {
        if (!this._ins) this._ins = this.$lv.newInstance(Object.assign({}, LinkSortFilterDialog, {
            beforeDestroy: () => {
                this._ins = null
            },
        }))
        return this._ins
    }

    constructor($lv) {
        this.$lv = $lv
    }

    show(option) {
        return this.instance.show(option)
    }
}

class LinkSelectFilter {

    id;
    value;
    text;

    constructor(data) {
        Object.assign(this, data)
        this.id = this.value
    }
}

export {LinkSortFilterService, LinkSelectFilter}